import React, { Component } from 'react';

import { SelectInput, SlButton, TextInput, SlBusyIndicator, SlMoneyInput, SlPageTitle, SlSectionTitle , SlEditorButton, SlFormEntryRow, ReadOnlyField } from '../editors';
import { Card, CardBody,  FormGroup, Label, Input, Col, Row } from 'reactstrap';
import { connect } from "react-redux";
import { Alert } from 'reactstrap';
import {history} from '../../_helpers'
import validator from 'validator';

import { newLoanActions } from "../../_actions";
import { metadataService, ProfileApi } from "../../_services";

class NewLoanApp extends Component {
    _isMounted =false; 
    static displayName = NewLoanApp.name;
    
    constructor(props) {
        super(props);
        this.VIEW_APPLY = 0; 
        this.VIEW_REVIEW = 1; 

        this.state = {
            isToggle: false, FirstName: '', LastName: '', value: '', MonthOfBirth: '', DayOfBirth: '', YearOfBirth: '', DOB:'',
            Email: '', ConfirmEmail: '', MobilePhone: '', Address: '', City: '', State: '', ZipCode: '', Income: '', BorrowAmount: '',
            incomeSource: '', incomeFrequency: '', "sendmeoffers": false, "age18years": false, "everythingcorrect": false, optInCreditReport: false,
            canMoveNext: false, isBusy: false, currentView: 0,
            fieldErrors: [],

        };

        this.handleClick = this.handleClick.bind(this);
        this.handleDataChange = this.handleDataChange.bind(this);
        this.handleValidation = this.handleValidation.bind(this);
        this.handleEditDetails = this.handleEditDetails.bind(this);
        this.handleSetState = this.handleSetState.bind(this);
        this.handleReviewApp = this.handleReviewApp.bind(this);
        
    }
    handleEditDetails() {
        this.handleSetState({ currentView: this.VIEW_APPLY });

    }

    handleReviewApp() {
        this.setState({ sendmeoffers: false, age18years: false, everythingcorrect: false, optInCreditReport: false });

        this.handleSetState({currentView: this.VIEW_REVIEW});
    }
    handleSetState(stateChanges){
        const newState = { ...this.state, ...stateChanges };
        stateChanges.canMoveNext = this.handleValidation(newState, false);
        this.setState(stateChanges);
    }
    componentDidMount(){
        this._isMounted = true; 
        if(!this.props.branchId){
            history.push("new-loan");
        }
        if(this.props.loggedIn){
            this.handleSetState({isBusy: true})
            ProfileApi.getExtendedProfileInfo().then(
                result => {
                    const p = result.data; 
                    
                    const newState = {
                        FirstName: p.firstName, 
                        LastName : p.lastName, 
                        Email : p.email, 
                        ConfirmEmail : p.email, 
                        MobilePhone: p.mobilePhone, 
                        Address1 : p.address1, 
                        Address2: p.address2, 
                        City : p.city, 
                        State: p.state, 
                        PostalCode : p.postalCode
                        , isBusy: false
                    }
                    this.handleSetState(newState);
                }
            )
        }
    }
    componentWillUnmount(){
        this._isMounted = false; 
    }
    handleClick(e) {
        this.setState({ isToggle: !this.state.isToggle });
    }

    setMoveNext(stateChanges) {
        const newState = { ...this.state, ...stateChanges };
        let canMoveNext = this.handleValidation(newState, false);
        return { ...stateChanges, ...{ canMoveNext: canMoveNext, errorMessage: null } };
    }
    
    handleValidation = (stateData, fromSubmit) => {
         //  alert('18 yrs: ' + stateData.age18years + ', everyhting correct: ' + stateData.everythingcorrect + ', Opt in: ' + stateData.optInCreditReport);
        let fieldErrors = [];

        this.setState({ fieldErrors: fieldErrors })      

        if (validator.isEmpty(stateData.FirstName + '') || validator.isEmpty(stateData.LastName + '')
            || validator.isEmpty(stateData.Address1 + '') || validator.isEmpty(stateData.City + '')
            || validator.isEmpty(stateData.City + '') || validator.isEmpty(stateData.PostalCode + '')
            || validator.isEmpty(stateData.IncomePerPeriod + '') || validator.isEmpty(stateData.PayFrequency + '')) {
                
            return false;
        }
        var dob = validator.toDate(stateData.DOB + '');
        if(dob === null || dob.getFullYear < 1900 ){
            
            return false; 
        }
        if (!validator.isNumeric(stateData.IncomePerPeriod + '') || !validator.isNumeric(stateData.RequestedAmount + '')) {
            
            return false;
        }

        if (!validator.isMobilePhone(stateData.MobilePhone + '', 'en-US')) {
            fieldErrors.push({ fieldName: "MobilePhone", messageName: "MobilePhoneError" });
            this.setState({ fieldErrors: fieldErrors });
            return false;
        }

        if (!validator.isEmail(stateData.Email + '') || !validator.isEmail(stateData.ConfirmEmail + '')) {
            
            return false;
        }

        if (!validator.equals(validator.normalizeEmail(stateData.Email + ''), validator.normalizeEmail(stateData.ConfirmEmail + ''))) {
            
            return false;
        }

        if (!fromSubmit) {
            if (stateData.age18years === false || stateData.everythingcorrect === false || stateData.optInCreditReport === false) {
                return false;
            }
        }

        return true;
        
    };

    submitClick = () => {
        const { dispatch } = this.props;

        if (this.handleValidation(this.state, true)) {

            var newLoanRequest = {
                "BranchId": this.props.branchId, 
                "BranchDetails": this.props.branchDetails, 
                "FirstName": this.state.FirstName, 
                "LastName": this.state.LastName, 
                "DateOfBirth": this.state.DOB, 
                "Email": this.state.Email, 
                "MobileNumber": this.state.MobilePhone, 
                "Address1": this.state.Address1, 
                "Address2": this.state.Address2, 
                "City": this.state.City, 
                "State": this.state.State, 
                "PostalCode": this.state.PostalCode, 
                "IncomePerPeriod": this.state.IncomePerPeriod, 
                "RequestedAmount": this.state.RequestedAmount, 
                "PrimaryIncome": this.state.PrimaryIncome, 
                "PayFrequency": this.state.PayFrequency
            }
            dispatch(newLoanActions.newLoanApp(newLoanRequest));
        }
    }

    handleChange(event) {
        this.handleSetState({ value: event.target.value });
    }

    handleDataChange(event) {
        let targetName = event.target.name;
        let stateChanges ={}
        if (targetName === 'source') {
            stateChanges.incomeSource = event.target.value ;
        } else if (targetName === 'frequency') {
            stateChanges.incomeFrequency = event.target.value ;
        } else if (targetName === 'sendmeoffers') {
            stateChanges.sendmeoffers = event.target.checked;
        } else if (targetName === 'age18years') {
            stateChanges.age18years = event.target.checked;
        } else if (targetName === 'everythingcorrect') {
            stateChanges.everythingcorrect = event.target.checked;
        } else if (targetName === 'optInCreditReport') {
            stateChanges.optInCreditReport = event.target.checked;
        }
        else {
            stateChanges[targetName] = event.target.value;
        }
        const newState = this.setMoveNext(stateChanges);
        this.setState(newState);
    }

    incomeSources = () => {
        
        return metadataService.getLookup('incomeSource');
    }

    incomeFrequencies = () => {
        return metadataService.getLookup('incomeFrequency');
    }

    render() {
        const { error, errorString, loggedIn } = this.props;
        return (
            <div className="NewLoanApp">
                <SlPageTitle pageName='Request_New'/>
                <div id="LogInFailed">
                    <Row className="justify-content-center">
                        {error && (
                            <Col xs={12} md={6}>
                                <Alert color="danger">
                                    <div id="failure"><p>An Error Occured on the page</p></div>
                                    <div id="failure"><p>{errorString}</p></div>
                                </Alert>
                            </Col>
                        )}
                    </Row>
                </div>
                <SlSectionTitle sectionName="LoanApplication"/>
                <SlBusyIndicator visible={this.state.isBusy}/>
                {this.state.currentView === this.VIEW_APPLY && (
                <div style={{display: this.state.isBusy? 'none' : 'block'}}>
                <SlSectionTitle sectionName='SectionMyInfo'/>
                <div className="loggedIn">
                <div>
                    {loggedIn && (
                        <Card>
                            <CardBody>
                                    <Row className="CustomerInfo">
                                        <Col sm={12} md={{ size: 6, offset: 3 }} >
                                            <p>{this.state.FirstName} {this.state.LastName}</p>
                                            <p>{this.state.Address1}</p>
                                            {/*{this.state.Address2 && (*/}
                                            {/*    <p>{this.state.Address2}</p>*/}
                                            {/*)}*/}
                                            <p>{this.state.City}, {this.state.State} {this.state.PostalCode}</p>
                                            <p>{this.state.EmailAddress}</p>
                                            <p>{metadataService.formatPhoneNumber(this.state.Mobile)}</p>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm={12} md={{ size: 6, offset: 3 }} >
                                            <TextInput name='DOB' value={this.state.DOB} onChange={this.handleDataChange} type='date'/>
                                        </Col>
                                    </Row>
                            </CardBody>
                        </Card>
                    )}
                </div>
                {!loggedIn  && (
                    
                        <div className="loggedOut">
                            <Card>
                                <CardBody>
                                        <Row className="CustomerInfo">
                                            <Col sm={12} md={{ size: 6, offset: 3 }} >
                                                <TextInput name='FirstName' value={this.state.FirstName} onChange={this.handleDataChange} maxLength="30"/>
                                                <TextInput name='LastName' value={this.state.LastName} onChange={this.handleDataChange} maxLength="30"/>
                                                <TextInput name='DOB' value={this.state.DOB} onChange={this.handleDataChange} type='date'/>
                                                <TextInput name='Email' value={this.state.Email} onChange={this.handleDataChange} type='email' />
                                                <TextInput name='ConfirmEmail' value={this.state.ConfirmEmail} onChange={this.handleDataChange} type='email' />
                                                <TextInput name='MobilePhone' value={this.state.MobilePhone} onChange={this.handleDataChange} fieldErrors={this.state.fieldErrors} type="number" maxLength="10"/>
                                                <TextInput name='Address1' value={this.state.Address1} onChange={this.handleDataChange}  maxLength="60"/>
                                                {/*<TextInput name='Address2' value={this.state.Address2} onChange={this.handleDataChange} isRequired={false} maxLength="60"/>*/}
                                                <TextInput name='City' value={this.state.City} onChange={this.handleDataChange} maxLength="60"/>
                                                <SelectInput name="State" value={this.state.State} options={metadataService.getLookup("state")} onChange={this.handleDataChange}/>
                                                <TextInput name='PostalCode' value={this.state.PostalCode} onChange={this.handleDataChange} type="number" maxLength="5"/>
                                            </Col>
                                        </Row>
                                </CardBody>
                            </Card>
                        </div>
                )}
                        <h5 className="text-center">{metadataService.getTitle("Income")}</h5>
                        <div>
                            <Card>
                                <CardBody>
                                        <Row>
                                            <Col sm={12} md={{ size: 6, offset: 3 }} >
                                                <SelectInput name='PrimaryIncome' value={this.state.PrimaryIncome}
                                                    onChange={this.handleDataChange} options={this.incomeSources()} />
                                                <SlMoneyInput name='IncomePerPeriod' value={this.state.IncomePerPeriod} 
                                                    onChange={this.handleDataChange} placeholder='$' labelName='Earnings' /> 
                                                <SelectInput name='PayFrequency' value={this.state.PayFrequency}
                                                    onChange={this.handleDataChange} options={this.incomeFrequencies()} />
                                            </Col>
                                        </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <h5 className="text-center">{metadataService.getTitle("BorrowAmount")}</h5>
                        <div>
                            <Card>
                                <CardBody>
                                    <Row>
                                        <Col sm={12} md={{ size: 6, offset: 3 }} >
                                            <SlMoneyInput name='RequestedAmount' value={this.state.RequestedAmount} onChange={this.handleDataChange} placeholder='$' showLabel={false}/> 
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                        <h5 className="text-center">{metadataService.getTitle("VerifyApplication")}</h5>
                        <div>
                            <Card>
                                <CardBody>
                                    <Row>
                    <Col sm={12} md={{ size: 6, offset: 3 }} >
                                            <FormGroup check>
                                                <Label check>
                                                    <Input type="checkbox" name="sendmeoffers" id="sendmeoffers" onChange={this.handleDataChange} /> {metadataService.getLabel("OptIn")}
                                        </Label>
                                            </FormGroup>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input type="checkbox" name="age18years" id="age18years" onChange={this.handleDataChange} />
                                                        {metadataService.getLabel("AgeVerification")}
                                        </Label>
                                            </FormGroup>
                                            <FormGroup check>
                                                <Label check>
                                                    <Input type="checkbox" name="everythingcorrect" id="everythingcorrect" onChange={this.handleDataChange} /> 
                                                    {metadataService.getLabel("AccurateInfo")}
                                                </Label>
                                                </FormGroup>
                                                <FormGroup check>
                                                    <Label check>
                                                        <Input type="checkbox" name="optInCreditReport" id="optInCreditReport" onChange={this.handleDataChange} />
                                                        {metadataService.getLabel("OptInCreditReport")}
                                                    </Label>
                                                </FormGroup>
                                        </Col>
                                    </Row>
                                </CardBody>
                            </Card>
                        </div>
                </div>
                
                <div className="text-center">
                    <SlButton name="Next" onClick={this.handleReviewApp} disabled={!this.state.canMoveNext}/>
                </div>
                </div>
                )}
                {this.state.currentView === this.VIEW_REVIEW && (
                    <div style={{display: this.state.isBusy? 'none' : 'block'}}>
                        <SlSectionTitle sectionName="SectionMyInfo"/>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <SlEditorButton onClick={this.handleEditDetails} />
                                            <SlFormEntryRow>
                                                {this.state.FirstName} {this.state.LastName}
                                            </SlFormEntryRow>
                                            <SlFormEntryRow>
                                                {this.state.Address1}
                                            </SlFormEntryRow>
                                            {this.state.Address2 && (
                                            <SlFormEntryRow>
                                                {this.state.Address2}
                                            </SlFormEntryRow>
                                            )}
                                            <SlFormEntryRow>
                                            {this.state.City}, {this.state.State} {this.state.PostalCode}
                                            </SlFormEntryRow>
                                            <SlFormEntryRow>
                                                {this.state.Email}
                                            </SlFormEntryRow>
                                            <SlFormEntryRow>
                                                {metadataService.formatPhoneNumber(this.state.MobilePhone)} 
                                            </SlFormEntryRow>
                                            <SlFormEntryRow>
                                                <ReadOnlyField name="DOB" value={metadataService.formatDateString(this.state.DOB)} vertical={false} valueAlignLeft={true}/>
                                            </SlFormEntryRow>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <SlSectionTitle sectionName="Income"/>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>    
                                        <SlEditorButton onClick={this.handleEditDetails} />
                                        <SlFormEntryRow>
                                            <ReadOnlyField name="PrimaryIncome" value={metadataService.getLookupText(metadataService.LOOKUP_INCOMESOURCE, this.state.PrimaryIncome)} 
                                                vertical={false} valueAlignLeft={true}/>
                                        </SlFormEntryRow>
                                        <SlFormEntryRow>
                                            <ReadOnlyField name="IncomePerPeriod" value={metadataService.formatMoney(this.state.IncomePerPeriod)} vertical={false} valueAlignLeft={true}/>
                                        </SlFormEntryRow>
                                        <SlFormEntryRow>
                                            <ReadOnlyField name="PayFrequency" value={metadataService.getLookupText(metadataService.LOOKUP_INCOMEFREQUENCY, this.state.PayFrequency)} 
                                                vertical={false} valueAlignLeft={true}/>
                                        </SlFormEntryRow>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <SlSectionTitle sectionName="RequestedAmount"/>
                        <Row>
                            <Col>
                                <Card>
                                    <CardBody>
                                        <SlEditorButton onClick={this.handleEditDetails} />
                                        <div className='text-center'>
                                            <span style={{fontSize: 'large'}}>{metadataService.formatMoney(this.state.RequestedAmount)}</span>
                                            </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                        <div className="text-center">
                        <SlButton name="Submit" onClick={this.submitClick} disabled={!this.state.canMoveNext}/>
                    </div>
                    </div>
                )}
            </div>
        );
    }



}



function mapStateToProps(state) {
    const { branchId, branchDetails, error, errorString } = state.newLoan;
    const { loggedIn } = state.authentication;
    return {
        branchId, branchDetails, error, errorString, loggedIn
    };
}

const connectedNewLoanApp = connect(mapStateToProps)(NewLoanApp);
export { connectedNewLoanApp as NewLoanApp };

//